/**
 * @file Youtube Setup.
 */

/**
 * Setup YouTube API.
 */
export default () => {
	if (!Object.prototype.hasOwnProperty.call(window, 'vYtCallbacks')) {
		window.vYtCallbacks = [];
		window.onYouTubeIframeAPIReady = () => {
			window.vYtCallbacks.forEach((callback) => {
				if (typeof callback === 'function') {
					callback();
				}
			});
		};
	}

	if (
		!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')
	) {
		// Load YouTube API
		const tag = document.createElement('script');

		tag.src = 'https://www.youtube.com/iframe_api';
		const firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	}
};
